import React, { useState, useEffect } from 'react';

const Dashboard = () => {
  const [date, setDate] = useState('');
  const [labName, setLabName] = useState('');
  const [orders, setOrders] = useState([{ dentistName: '', delivery: false, pickup: false }]);
  const [comment, setComment] = useState('');
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const savedName = localStorage.getItem('marcel_company_name');
    const savedOrders = localStorage.getItem('marcel_saved_clients');
    if (savedName) setLabName(savedName);
    if (savedOrders) {
      const parsed = JSON.parse(savedOrders);
      setOrders(parsed.map(o => ({ ...o, delivery: false, pickup: false })));
    }
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleAddOrder = () => setOrders([...orders, { dentistName: '', delivery: false, pickup: false }]);
  const handleRemoveOrder = (index) => setOrders(orders.filter((_, i) => i !== index));
  const handleOrderChange = (index, field, value) => {
    const newOrders = [...orders];
    newOrders[index][field] = value;
    setOrders(newOrders);
  };

  const handleReset = () => {
    if (window.confirm("Voulez-vous supprimer vos données sauvegardées ?")) {
      localStorage.clear();
      setLabName('');
      setOrders([{ dentistName: '', delivery: false, pickup: false }]);
      alert("Mémoire réinitialisée.");
    }
  };

  const generateWhatsAppLink = () => {
    if (!date || !labName) return alert("Erreur : Date et Nom d'entreprise obligatoires.");
    const isValid = orders.every(o => o.dentistName && (o.delivery || o.pickup));
    if (!isValid) return alert("Erreur : Chaque destination doit avoir une mission (Livraison/Retour).");

    localStorage.setItem('marcel_company_name', labName);
    localStorage.setItem('marcel_saved_clients', JSON.stringify(orders.map(o => ({ dentistName: o.dentistName }))));

    const phoneNumber = "33649292905";
    let message = `🚀 NOUVEL ORDRE DE TRANSPORT - ${date}`;
    message += `\n🏢 EXPÉDITEUR : ${labName.toUpperCase()}`;
    message += '\n\n' + orders.map(order => 
      `• ${order.dentistName.toUpperCase()}: ${order.delivery ? '[LIVRAISON]' : ''}${order.pickup ? '[RETOUR]' : ''}`
    ).join('\n');
    message += `\n\n📝 NOTE : ${comment || 'Aucune'}`;

    window.location.href = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
  };

  const styles = {
    container: { maxWidth: '850px', margin: '0 auto', padding: '20px', fontFamily: 'Arial, sans-serif', textAlign: 'center' },
    title: { color: '#C4392D', fontSize: isMobile ? '2.2rem' : '4rem', fontWeight: '900', textTransform: 'uppercase', marginBottom: '5px' },
    securityBanner: { backgroundColor: '#fff', padding: '20px', borderRadius: '20px', border: '2px solid #C4392D', marginBottom: '25px', textAlign: 'left', boxShadow: '0 10px 30px rgba(0,0,0,0.05)' },
    ovhLink: { display: 'inline-block', color: '#C4392D', fontWeight: 'bold', textDecoration: 'underline', marginTop: '10px' },
    rulesBox: { backgroundColor: '#fdf2f2', padding: '15px', borderRadius: '15px', borderLeft: '5px solid #C4392D', marginBottom: '20px', fontSize: '0.9rem' },
    form: { backgroundColor: '#fff', padding: isMobile ? '20px' : '40px', borderRadius: '30px', boxShadow: '0 20px 60px rgba(0,0,0,0.1)', textAlign: 'left' },
    input: { width: '100%', padding: '15px', marginBottom: '15px', border: '2px solid #eee', borderRadius: '12px', fontSize: '16px', boxSizing: 'border-box' },
    btnMain: { width: '100%', padding: '20px', backgroundColor: '#C4392D', color: 'white', border: 'none', borderRadius: '15px', fontWeight: '900', fontSize: '1.2rem', cursor: 'pointer', textTransform: 'uppercase' },
    installGuide: { marginTop: '25px', padding: '15px', backgroundColor: '#eee', borderRadius: '15px', fontSize: '0.8rem', textAlign: 'left', color: '#555' }
  };

  return (
    <div style={{ backgroundColor: '#fafafa', minHeight: '100vh', paddingBottom: '40px' }}>
      <div style={styles.container}>
        <header>
          <h1 style={styles.title}>TRANSPORTS MARCEL</h1>
          <p style={{ fontWeight: '800', fontSize: '1rem' }}>LOGISTIQUE & COURSIER EXPRESS 06</p>
        </header>

        <div style={styles.securityBanner}>
          <strong style={{color: '#C4392D', fontSize: '1.1rem'}}>🔒 ACCÈS RÉSERVÉ</strong>
          <p style={{margin: '10px 0', fontSize: '0.95rem', lineHeight: '1.5'}}>
            Ce service est destiné uniquement aux <b>clients enregistrés</b> ou connus de nos services pour la gestion opérationnelle.
          </p>
          <div style={styles.rulesBox}>
            <strong>📢 RÈGLES DE SERVICE :</strong><br/>
            • Merci de respecter votre tranche horaire d'envoi définie au préalable.<br/>
            • Tout ordre hors créneau pourra être repassé au lendemain.<br/>
            • En cas de doute, veuillez nous contacter immédiatement.
          </div>
          <p style={{margin: '0', fontSize: '0.85rem'}}>Pour toute autre demande ou contact :</p>
          <a href="https://transportsmarcel.ovh" style={styles.ovhLink}>👉 CLIQUEZ ICI POUR ACCÉDER À NOTRE SITE OFFICIEL</a>
        </div>

        <form onSubmit={(e) => { e.preventDefault(); generateWhatsAppLink(); }} style={styles.form}>
          <label style={{fontWeight: 'bold', fontSize: '0.8rem'}}>📅 DATE DE TOURNÉE *</label>
          <input type="date" value={date} onChange={(e) => setDate(e.target.value)} style={styles.input} required />

          <label style={{fontWeight: 'bold', fontSize: '0.8rem'}}>🏢 VOTRE SOCIÉTÉ *</label>
          <input type="text" placeholder="Sauvegarde automatique..." value={labName} onChange={(e) => setLabName(e.target.value)} style={styles.input} required />

          <div style={{marginTop: '10px'}}>
            <p style={{fontWeight: '900', fontSize: '0.9rem', color: '#C4392D'}}>📋 MISSIONS À EFFECTUER</p>
            {orders.map((order, index) => (
              <div key={index} style={{ padding: '15px', backgroundColor: '#fcfcfc', borderRadius: '15px', marginBottom: '10px', border: '1px solid #eee' }}>
                <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '10px'}}>
                  <span style={{fontSize: '0.7rem', fontWeight: 'bold', color: '#999'}}>ORDRE #{index + 1}</span>
                  {orders.length > 1 && <button type="button" onClick={() => handleRemoveOrder(index)} style={{color: '#ff4444', border: 'none', background: 'none', cursor: 'pointer'}}>Effacer</button>}
                </div>
                <input type="text" placeholder="Client final / Destination *" value={order.dentistName} onChange={(e) => handleOrderChange(index, 'dentistName', e.target.value)} style={styles.input} required />
                <div style={{ display: 'flex', gap: '20px' }}>
                  <label style={{cursor: 'pointer', fontWeight: 'bold'}}><input type="checkbox" checked={order.delivery} onChange={(e) => handleOrderChange(index, 'delivery', e.target.checked)} /> 🚛 LIVRAISON</label>
                  <label style={{cursor: 'pointer', fontWeight: 'bold'}}><input type="checkbox" checked={order.pickup} onChange={(e) => handleOrderChange(index, 'pickup', e.target.checked)} /> 🔄 RETOUR</label>
                </div>
              </div>
            ))}
          </div>

          <button type="button" onClick={handleAddOrder} style={{ width: '100%', padding: '12px', marginBottom: '20px', borderRadius: '12px', border: '2px dashed #eee', cursor: 'pointer', fontWeight: 'bold', color: '#666' }}>+ Ajouter une destination</button>
          
          <label style={{fontWeight: 'bold', fontSize: '0.8rem'}}>📝 NOTES PARTICULIÈRES</label>
          <textarea placeholder="Instructions chauffeur..." value={comment} onChange={(e) => setComment(e.target.value)} style={{ ...styles.input, minHeight: '80px' }} />
          
          <button type="submit" style={styles.btnMain}>TRANSMETTRE VIA WHATSAPP</button>
          <button type="button" onClick={handleReset} style={{ background: 'none', border: 'none', color: '#bbb', width: '100%', marginTop: '20px', cursor: 'pointer', fontSize: '0.7rem', textDecoration: 'underline' }}>Réinitialiser la mémoire locale</button>
        </form>

        <div style={styles.installGuide}>
          <strong>📲 AJOUTER À L'ÉCRAN D'ACCUEIL :</strong><br/>
          • <b>iPhone</b> : Partager (↑) > "Sur l'écran d'accueil".<br/>
          • <b>Android</b> : Menu (⋮) > "Ajouter à l'écran d'accueil".
        </div>

        <footer style={{ marginTop: '30px', color: '#ccc', fontSize: '0.7rem' }}>
          © 2025 GROUPE TRANSPORTS MARCEL | TOUS DROITS RÉSERVÉS
        </footer>
      </div>
    </div>
  );
};

export default Dashboard;
